import { render, staticRenderFns } from "./DormUserComments.vue?vue&type=template&id=3deedc3c&"
import script from "./DormUserComments.vue?vue&type=script&lang=js&"
export * from "./DormUserComments.vue?vue&type=script&lang=js&"
import style0 from "./DormUserComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports